import { render, staticRenderFns } from "./InductionHeatingViz.vue?vue&type=template&id=d4b66f30&scoped=true"
import script from "./InductionHeatingViz.vue?vue&type=script&lang=js"
export * from "./InductionHeatingViz.vue?vue&type=script&lang=js"
import style0 from "./InductionHeatingViz.vue?vue&type=style&index=0&id=d4b66f30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b66f30",
  null
  
)

export default component.exports